import {Moment} from 'moment-timezone'

import {DeliveryTime, SlotSiloConfig} from '../../../../../OrderIntake/declarations/types'

export interface Slot {
  materialNumber: string
  slotDurationMinutes: string
  loadingStation: string
  siloNumber: string
  id: string
  plantId: string
  date: string
  slotConfig: SlotConfig
  slotStatus: SlotStatus
  serviceResponseCode: string
}

export interface SlotConfig {
  slotStart: string
  slotEnd: string
  isAlwaysFull: boolean
  slotPosition: number
}

export interface SlotStatus {
  statusName: string
  isBlockingDelivery: boolean
}

export interface TimeSlotSectionProps {
  title: string
  selectedDeliveryTimeSlot?: DeliveryTime
  setSelectedDeliveryTimeSlot?: (value: DeliveryTime) => void
  slots: Slot[]
  onChange: (value: DeliveryTime) => void
  setSelectedSlotSiloConfig: (value: SlotSiloConfig) => void
  setSelectedSlot: (value: Slot) => void
  externalReference: string
}

export interface SlotFilter {
  startDate: string
  endDate: string
  country: string
  plantId: string
  materialNumber: string
}

export interface TimeSlotProps {
  setSelectedDeliveryTimeSlot?: (value: DeliveryTime) => void
  setSelectedSlotSiloConfig: (value: SlotSiloConfig) => void
  setSelectedSlot: (value: Slot) => void
  selectedDeliveryTimeSlot?: DeliveryTime
  name: string
  isLoading: boolean
  isSuccess: boolean
  value: DeliveryTime
  selectedDate: Moment | null
  slots: Slot[]
  onChange: (value: DeliveryTime) => void
  isError: boolean
  externalReference: string
}

export interface ReserveSlotRequest {
  country: string
  plantId: string
  materialNumber: string
  bookingDate: string
  loadingStation: string
  siloNumber: string
  bookedTimeFrom: string
  bookedTimeTo: string
  slotDurationMinutes: string
  externalReference: string
  applicationId: string
  userId: string
}

export interface ReserveSlotResponse {
  messageType: string
  classId: string
  messageNumber: string
  message: string
}

export enum OrderWindowStatus {
  Reserved = 'reserved',
  Expired = 'expired',
  Unreserved = 'unreserved'
}

export interface ReleaseSlotRequest {
  country: string
  externalReference: string
  applicationId: string
  userId: string
}

export interface SlotReleaseData {
  externalReference: string
  plantId: string
  materialNumber: string
}
